import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminProductSolutionContents = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_CONTENTS.GET_ALL, { params });
    return response.data;
};

export const getAdminProductSolutionContentById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_CONTENTS.GET_BY_ID(id));
    return response.data;
};

export const createProductSolutionContent = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_CONTENTS.CREATE, data);
    return response.data;
};

export const updateProductSolutionContent = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_CONTENTS.UPDATE(id), data);
    return response.data;
};

export const deleteProductSolutionContent = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_CONTENTS.DELETE(id));
    return response.data;
};
